import { ReactNode } from 'react';
import { withStyles } from 'vopay';
import { BodyText, Card } from 'UI';
import styles from './DetailsModule.module.scss';

const cn = withStyles(styles);

type DetailsModuleProps = {
  title: string;
  'data-testid': string;
  children: ReactNode;
};

/** Spec 5.6.1 "Module": a small title over a card of detail rows. */
export default function DetailsModule({ title, 'data-testid': testId, children }: DetailsModuleProps) {
  return (
    <section className={cn('module')} aria-label={title} data-testid={testId}>
      {/* Figma: Body/13/Medium */}
      <BodyText size="sm" weight="md">
        {title}
      </BodyText>

      <Card variant="section" className={cn('card')}>
        {children}
      </Card>
    </section>
  );
}
